<script setup>
import { frames } from '../../../../utils/frames'
import SkewedEllipsMask from './SkewedEllipsMask.vue'
const gsapTimeline = useGsapTimeline()

const maskElement = ref(null)

const emit = defineEmits(['timeline', 'disappearTimeline'])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'AnimatedSkewedEllipsMask' }).from(maskElement, { maskSize: 0, duration: frames(10), ease: 'power1.out' }, '<')

  emit('timeline', timeline)

  emit('disappearTimeline', () => {
    return gsapTimeline({ name: 'AnimatedSkewedEllipsMask - Disappear' }).to(maskElement, { maskSize: 0, duration: frames(10), ease: 'power1.in' }, '<')
  })
})
</script>

<template>
  <SkewedEllipsMask ref="maskElement">
    <slot />
  </SkewedEllipsMask>
</template>
